<template>
  <div style="height: 100%;">
    <div style="margin-bottom: 8px;text-align: right;">
      <a-button v-tc="{ name: '新增人员' }" @click="openAdd">
        新增人员
      </a-button>
    </div>
    <div class="content">
      <a-table :bordered="true" :pagination="false" size="small" :data-source="dataList">
        <a-table-column title="人员名称">
          <template slot-scope="text, record">
            <a-select
              v-if="record.isEdit"
              v-model="record.user_id"
              style="width: 100%;"
              placeholder="请选人员"
              show-search
              :filter-option="utils.filterOption"
              @select="selectUser(record)"
            >
              <a-select-option v-for="(user, index) in $store.state.allUsers" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
            </a-select>
            <span v-else>
              {{ record.nickname }}
            </span>
          </template>
        </a-table-column>
        <a-table-column width="150px" title="操作">
          <template slot-scope="record">
            <a-button v-if="record.isEdit" size="small" type="link" @click="saveRow(record)">
              保存
            </a-button>
            <a-popconfirm
              title="确定删除这条数据?"
              ok-text="是"
              cancel-text="否"
              @confirm="delRow(record)"
            >
              <a-button v-tc="{ name: '删除' }" size="small" type="link">
                删除
              </a-button>
            </a-popconfirm>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <AddOrEdit ref="addOrEditRef" :data-list="dataList" :selected-key="selectedKey" />
  </div>
</template>

<script>
import AddOrEdit from './AddOrEdit.vue';
import { modifyTicketConfig } from '@/api/event/problem';
export default {
  components: {
    AddOrEdit
  },
  props: {
    selectedKey: {
      type: String,
      default: ''
    },
    selectedValue: {}
  },
  data() {
    return {
      dataList: []
    };
  },
  watch: {
    selectedValue: {
      handler() {
        // {fs_user_id: "95353ed3",nickname: "徐乾彭"user_id:735}
        this.dataList = this.selectedValue || [];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    selectUser(record) {
      const usr = this.$store.state.allUsers.find(u => u.id === record.user_id);
      if (usr) {
        record.fs_user_id = usr.fs_user_id;
        record.nickname = usr.nickname;
      }
    },
    saveRow(record) {
      if (!record.fs_user_id || !record.nickname || !record.user_id) {
        this.$message.error('请填写完整信息');
        return;
      }
      this.$delete(record, 'isEdit');
      this.updateData();
    },
    delRow(record) {
      this.dataList = this.dataList.filter(item => item.user_id !== record.user_id);
      this.updateData();
    },
    openAdd() {
      // this.$refs.addOrEditRef.open();
      this.dataList.push({ 'fs_user_id': undefined, 'nickname': undefined, 'user_id': undefined, isEdit: true });
    },
    updateData() {
      modifyTicketConfig({
        info: this.dataList || [],
        number: this.selectedKey
      })
        .then(res => {
          this.$message.success('保存成功');
          this.$store.dispatch('getGlobalConfigList');
        })
        .catch(() => {
        });
    }
  }
};
</script>

<style lang="less" scoped>

</style>
